<template>
    <div class="modal fade" id="modal-filter" role="dialog" data-backdrop="static">
        <div class="modal-dialog modal-lg bani-modal h-100">
            <div class="modal-content w-limit vh-100" style="border-radius: 0">
                <div class="modal-header">
                    <div class="nav-btn kiri tutup">
                        <img src="../../../../assets/img/x2.svg" @click="back" alt="" />
                    </div>
                    <h5 class="navbar-title text-center">Filter</h5>
                    <div class="nav-btn kanan"></div>
                </div>

                <div class="content-wrapper">
                    <div class="vh-100">
                        <slot name="filters"></slot>
                    </div>

                    <div class="nav-bottom-wrapper">
                        <div class="p-x-20 d-flex-between-center w-limit">
                            <button class="btn btn-outline-primary btn-long m-r-12" @click="resetFilter">
                                Reset
                            </button>
                            <button class="btn btn-primary btn-long" @click="doFilter">
                                Terapkan
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

const moduleName = "filterGlobalModule";

export default {
    name: "SOFilterBase",
    components: {},
    props: {
        needVerify: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            filterItemCopy: {},
            filterSortCopy: {},
            verifyValue: true,
        };
    },
    mounted() {
        $("#modal-filter").modal("show");
        this.filterItemCopy = JSON.parse(JSON.stringify(this.filterItem));
        this.filterSortCopy = JSON.parse(JSON.stringify(this.filterSort));
    },
    beforeDestroy() {
        this.$store.commit("filterGlobalModule/resetFilterSetting");
    },
    computed: {
        ...mapGetters(moduleName, {
            filterItem: "getFilterItem",
            filterSort: "getFilter",
            filterSetting: "getFilterSetting",
        }),
    },
    methods: {
        back(payload) {
            $("#modal-filter").modal("hide");
            this.$store.commit("filterGlobalModule/setFilterItem", this.filterItemCopy);
            this.$store.commit("filterGlobalModule/setFilter", this.filterSortCopy)
            setTimeout(() => {
                this.$emit("back", payload);
            }, 500);
        },
        resetFilter() {
            this.$store.commit("filterGlobalModule/resetFilterItem");
            this.$store.commit("filterGlobalModule/resetFilter");
            this.$emit("reset-filter");
        },
        setVerify(v) {
            this.verifyValue = v
        },
        doFilter(payload) {
            if(this.needVerify) {
                this.$emit('verify')
                console.log();
                if (!this.verifyValue) {
                    return
                }
            }
            $("#modal-filter").modal("hide");
            this.$router.replace({ query: null });
            this.$emit("do-filter", payload);
        },
    },
};
</script>

<style>
.nav-bottom-wrapper {
    position: sticky;
    left: 0;
    width: 100%;
    bottom: 0px;
    background: white;
    box-shadow: 0px -6px 12px rgba(0, 0, 0, 0.05);
}
</style>
